import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

export const SectionWrapperStyle = css`
  position: relative;

  ${({ $tone }) => {
    switch ($tone) {
      case 'zircon':
        return css`
          background-image: var(--colors-zircon);
        `;
      case 'green':
        return css`
          background-image: unset;
          background: #dfefd3;
        `;
      case 'lavenderBlush':
        return css`
          background-image: unset;
          background: #fef7f9;
        `;
      case 'pink':
        return css`
          background-image: unset;
          background: #f8d8dd;
        `;
      case 'brown':
        return css`
          background-image: unset;
          background: #300f0d;
        `;
      case 'purpleMinsk':
        return css`
          h1,
          h2,
          h3 {
            color: var(--colors-blank);
          }
          background-image: var(--colors-purpleMinsk);
        `;
      case 'white':
      case 'blank':
        return css`
          background-image: none;
          background-color: var(--colors-blank);
        `;
      default:
        return css`
          background-image: none;
          background-color: transparent;
        `;
    }
  }}

  ${({ $size }) => {
    switch ($size) {
      case 'small':
        return css`
          ${fluidProp(['padding-top', 'padding-bottom'], '50px', '100px')}
        `;
      default:
        return css`
          ${fluidProp(['padding-top', 'padding-bottom'], '80px', '160px')}
        `;
    }
  }}

  ${({ $background }) =>
    $background &&
    css`
      background-image: url('${$background}');
      background-size: cover;
    `}
`;

export const SectionWrapper = styled.section`
  ${SectionWrapperStyle}
`;
